<script>
    let { nav, currentTab, onSelectItem } = $props();
    import { getMobileOS } from "@utils/common";
</script>

<!-- svelte-ignore element_invalid_self_closing_tag -->
<!-- svelte-ignore a11y_click_events_have_key_events -->
<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
<!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
<nav class="nav {getMobileOS()}">
    <ul>
        {#each nav as item, index}
            <li
                onclick={() => onSelectItem(item.id)}
                class={item.id === currentTab ? "--active" : ""}
            >
                <i class="fal {item.icon}" />{item.text}
            </li>
        {/each}
    </ul>
</nav>

<style lang="scss">
    @use "./styles/index.scss";
</style>
